<template>
  <div class="skeleton-record">
    <!-- Record Item 列表骨架 -->
    <div class="skeleton-record-list">
      <div v-for="i in 10" :key="i" class="skeleton-record-item h-55px">
        <!-- <div class="skeleton-record-left">
          <div class="skeleton-record-icon"></div>
          <div class="skeleton-record-info">
            <div class="skeleton-record-title"></div>
            <div class="skeleton-record-time"></div>
          </div>
        </div>
        <div class="skeleton-record-right">
          <div class="skeleton-record-amount"></div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import theme from '@/styles/theme'
</script>

<style scoped lang="scss">
@keyframes skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.skeleton-record {
  padding: 0 0px;
  
  %skeleton-base {
    background: linear-gradient(
      90deg,
      v-bind('theme.colors.backgroundSecondary') 25%,
      rgba(255, 255, 255, 0.05) 50%,
      v-bind('theme.colors.backgroundSecondary') 75%
    );
    background-size: 200% 100%;
    animation: skeleton-shimmer 1.5s ease-in-out infinite;
    border-radius: 8px;
  }
  
  .skeleton-record-list {
    .skeleton-record-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      margin-bottom: 10px;
      border-radius: 10px;
      // background-color: v-bind('theme.colors.backgroundSecondary');
      @extend %skeleton-base;
      
      .skeleton-record-left {
        display: flex;
        align-items: center;
        flex: 1;
        
        .skeleton-record-icon {
          @extend %skeleton-base;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          margin-right: 10px;
          flex-shrink: 0;
        }
        
        .skeleton-record-info {
          flex: 1;
          
          .skeleton-record-title {
            @extend %skeleton-base;
            height: 16px;
            width: 120px;
            margin-bottom: 8px;
          }
          
          .skeleton-record-time {
            @extend %skeleton-base;
            height: 12px;
            width: 80px;
          }
        }
      }
      
      .skeleton-record-right {
        .skeleton-record-amount {
          @extend %skeleton-base;
          height: 20px;
          width: 60px;
        }
      }
    }
  }
}
</style>

